import axios from "networking/axios/axios";
import * as endpoints from "networking/endpoints/endpoints";

export const addSellerApi = (data) =>
    Promise.resolve(axios.post(endpoints.addSeller, data));
